var map = {
	"./01.svg": 77192,
	"./02.svg": 80568,
	"./03.svg": 17740,
	"./04.svg": 19720,
	"./05.svg": 32344,
	"./06.svg": 49852,
	"./07.svg": 57268,
	"./08.svg": 68148,
	"./09.svg": 26512,
	"./1.svg": 32996,
	"./10.svg": 73924,
	"./11.svg": 4028,
	"./111.svg": 64792,
	"./12.svg": 78520,
	"./13.svg": 10268,
	"./14.svg": 26736,
	"./15.svg": 9068,
	"./16.svg": 61972,
	"./17.svg": 56696,
	"./18.svg": 23548,
	"./19.svg": 41459,
	"./2.svg": 6012,
	"./20.svg": 12848,
	"./21.svg": 66616,
	"./22.svg": 21148,
	"./23.svg": 31912,
	"./24.svg": 2796,
	"./25.svg": 16248,
	"./26.svg": 23936,
	"./27.svg": 75148,
	"./28.svg": 95148,
	"./29.svg": 35851,
	"./3.svg": 48008,
	"./30.svg": 99580,
	"./31.svg": 96100,
	"./32.svg": 61420,
	"./4.svg": 46748,
	"./5.svg": 77212,
	"./6.svg": 19612,
	"./7.svg": 69316,
	"./8.svg": 44900,
	"./9.svg": 268,
	"./a.svg": 76208,
	"./abc.svg": 56000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31579;